<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('SystemConfigElements') }}
      <template #action>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          order="-1"
          style="background-color: #ffff87;"
          @click="updateAllConfig"
        >
          <v-icon
            color="black"
            left
          >
            mdi-content-save
          </v-icon>
          {{ $t('save') }}
        </v-btn>
      </template>
    </page-header>
    <div>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="black"
        show-arrows
        style="background: transparent"
      >
        <v-tab
          v-for="(tag,index) in tagListGroup"
          :key="index"
        >
          {{ $t(tag) }}
        </v-tab>
      </v-tabs>
      <v-divider />
    </div>
    <v-tabs-items
      v-model="tab"
      style="background-color: transparent"
    >
      <loading-provider :loading="loading">
        <v-tab-item
          v-for="(tag,index) in tagListGroup"
          :key="index"
        >
          <v-card
            v-for="(item,index) in groupConfigBySection"
            :key="index"
            class="mt-4"
            elevation="0"
            outlined
          >
            <div class="d-flex align-center justify-center pa-4">
              <div class="text-h4 font-weight-bold">
                {{ $t(index) }}
              </div>
              <v-spacer />
            </div>
            <v-divider
              style="background-color: gray"
            />
            <div
              v-for="(it,_index) in item"
              :key="_index"
            >
              <div
                class="d-flex align-center justify-center my-4"
              >
                <div
                  class="text-h5 font-weight-bold px-4"
                  style="min-width: 400px"
                >
                  {{ $t(it.sKey) }}
                </div>
                <v-spacer />
                <v-select
                  v-if="it.sType === 'options'"
                  v-model="it.sValue"
                  :items="it.sOptions.split(',')"
                  :menu-props="{overflowY: true, outlined: true, contentClass: 'elevation-2 ikRounded', nudgeBottom: '48px'}"
                  :placeholder="it.defaultValue"
                  dense
                  hide-details
                  outlined
                />
                <v-text-field
                  v-else-if="it.sType === 'string'"
                  v-model="it.sValue"
                  :placeholder="it.defaultValue"
                  dense
                  hide-details
                  outlined
                  style="max-width: 400px"
                />
                <v-switch
                  v-else

                  v-model="it.sValue"
                  :placeholder="it.defaultValue"
                  class="ma-0"
                  color="amber"
                  hide-details
                />
              </div>
              <v-divider
                style="background-color: #d0d0d0"
              />
            </div>
          </v-card>
        </v-tab-item>
      </loading-provider>
    </v-tabs-items>
  </div>
</template>

<script>

import PageHeader from '@/views/widget/typography/PageHeader.vue'
import {
  addSystemSettings,
  getNewSettingList,
  getSystemVersion,
  updateNewSetting
} from '@/model/dataLayer/api/NewSettings'
import { groupBy, uniqBy } from 'lodash'
import { showSuccessMessage } from '@/model/utils/utils'
import LoadingProvider from '@/views/widget/LoadingProvider'

export default {
  components: {
    LoadingProvider,
    PageHeader
  },
  data: function () {
    return {
      loading: false,
      systemVersion: '',
      tab: null,
      configList: [],
      section: '',
      tagListGroup: [],
      sKey: '',
      sValue: ''
    }
  },
  computed: {
    groupConfigBySection () {
      return groupBy(this.realConfigInfo, 'section')
    },
    realConfigInfo () {
      return this.configList.filter(it => it.tagList.includes(this.tagListGroup[this.tab]))
    }
  },
  watch: {
    tab (val) {
      console.log(val, 'val')
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async updateAllConfig () {
      this.loading = true
      this.configList.filter(it => it.sType === 'boolean').map(x => {
        if (!x.sValue) {
          x.sValue = '0'
        } else {
          x.sValue = '1'
        }
        return x
      })
      await updateNewSetting(this.configList)
      await addSystemSettings(this.configList)
      showSuccessMessage('UpdateSuccessfully')
      await this.reload()
      this.loading = false
    },
    async reload () {
      this.loading = true
      this.configList = await getNewSettingList()
      this.configList.filter(it => it.sType === 'boolean').map(x => {
        x.sValue = x.sValue !== '0'
        return x
      })
      this.tagListGroup = uniqBy(this.configList.map(it => it.tagList).join(',').split(','))
      this.systemVersion = await getSystemVersion()
      console.log(this.configList, 'list')
      this.loading = false
    }
  }
}
</script>
